var _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardAssociate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "257,235 271,220 320,270 271,320 257,305 282,280 190,280 190,260 282,260 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 320l0 0c0,-23 9,-44 25,-60 15,-15 36,-24 59,-24 24,0 45,9 60,24l0 0 0 0c15,16 25,37 25,60l-20 0c0,-18 -8,-34 -19,-45l0 -1c-12,-11 -28,-18 -46,-18 -17,0 -34,7 -45,19 -12,11 -19,27 -19,45l0 0 -20 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 124c18,0 35,8 47,19 12,12 19,29 19,47 0,18 -7,34 -19,46 -12,12 -29,19 -47,19 -18,0 -34,-7 -46,-19 -12,-12 -19,-28 -19,-46 0,-18 7,-35 19,-47 12,-11 28,-19 46,-19zm33 34c-9,-9 -20,-14 -33,-14 -12,0 -24,5 -32,14 -8,8 -13,19 -13,32 0,12 5,24 13,32 8,8 20,13 32,13 13,0 24,-5 33,-13 8,-8 13,-20 13,-32 0,-13 -5,-24 -13,-32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardAssociate);
export default __webpack_public_path__ + "static/media/forward-associate.193b8356.svg";
export { ForwardRef as ReactComponent };